import { defaultEntityState } from '@core/state/entities/entity';
import {
  normalizeAndMergeEntity,
  mergeEntityState,
} from '@core/state/entities/entity.helpers';
import {
  IScreening,
  screeningSchema,
} from '@core/state/entities/screening/screening.entity';
import { studyOutgoingDtoSchema } from '@core/services/stage/review-effects';
import { createReducer, on } from '@ngrx/store';
import {
  incompleteStudiesPayloadSchema,
  stageActions,
  stageStudyActions,
} from '@core/actions/stage.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const screeningEntityReducer = createReducer(
  defaultEntityState<IScreening>(),
  on(stageStudyActions.receivedStageStudy, (state, props) =>
    mergeEntityState(entityKey.screenings, state, props)
  ),

  on(stageActions.submitScreeningAndNextStudy, (state, props) =>
    normalizeAndMergeEntity(entityKey.screenings, state, props, {
      screening: screeningSchema,
    })
  ),
  on(stageActions.receivedInProgressStudies, (state, props) =>
    mergeEntityState(entityKey.screenings, state, props)
  ),
  on(stageActions.incompleteSessionsUpdated, (state, props) =>
    normalizeAndMergeEntity(
      entityKey.screenings,
      state,
      props,
      incompleteStudiesPayloadSchema
    )
  ),
  on(stageActions.saveSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : normalizeAndMergeEntity(
          entityKey.screenings,
          state,
          props,
          studyOutgoingDtoSchema
        )
  )
);
